import createReactComponent from '../createReactComponent';
export default createReactComponent('chevron-right', 'ChevronRight', [["path",{"d":"m9 18 6-6-6-6","key":"svg-0"}]]);